import React from "react";

interface ProfileDetailRowProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
}

const ProfileDetailRow: React.FC<ProfileDetailRowProps> = ({ icon, label, value}) => (
  <div className="grid grid-cols-[24px_minmax(140px,190px)_auto_1fr] gap-3 py-3 border-b border-gray-200">
    <span className="text-gray-600 flex-shrink-0">{icon}</span>
    <span className="font-medium text-gray-800">{label}</span>
    <span className="text-gray-600 break-words">: {value}</span>
  </div>
);

export default ProfileDetailRow;
